import { api } from "@api/api";
import { Discount } from "@modules/discounts/types";
import { DiscountFormValues } from "@modules/discounts/validations";

export async function editDiscountService(id: string, data: Partial<DiscountFormValues>): Promise<Discount> {
  const { image, ...body } = data;
  const payload = !image ? { ...body, image: null } : body;

  const { data: discount } = await api.patch<Discount>(`v1/discount_admin/${id}/`, payload);

  if (image && image instanceof File) {
    const formData = new FormData();
    formData.append("image", image);

    const { data: discount } = await api.patch<Discount>(`v1/discount_admin/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return discount;
  }


  return discount;
}